import apiClient from "../common";

const INCOMING_ORDERS_LIST_PATH =
  "coverage_simulator/products/incoming/orders/list/";

export const ApiLoadOrderList = async (sessionCreatedOnly: boolean = false) => {
  const params = sessionCreatedOnly ? { added_in_session: true } : undefined;
  return apiClient.get(INCOMING_ORDERS_LIST_PATH, { params });
};

export const ApiUpdateOrderList = async (orderData: unknown) => {
  return apiClient.patch(
    INCOMING_ORDERS_LIST_PATH,
    { buy_orders: orderData },
    { headers: { "Content-Type": "application/json" } },
  );
};